export const fbStatus = {
  PENDING: "Pending",
  COMPLETED: "Completed",
};
